import { type Enum } from '@webapp/infrastructure/types/Enum'

export const ConversationComponentTypes = {
  MESSAGE: 'message',
  CONFIRMATION_OPTIONS: 'confirmation_options',
  GROUPED_DROPDOWN: 'grouped_dropdown',
  CART: 'cart',
  CHECKOUT: 'checkout',
  CATALOG_ITEM: 'catalog_item',
  TEXT: 'text',
  ORDER_CONFIRMATION: 'order_confirmation',
  PAYMENT_METHODS: 'payment_methods',
  A2UI: 'a2ui',
} as const

export type ConversationComponentTypeEnum = Enum<
  typeof ConversationComponentTypes
>
